import axios from "axios";
import { API_BASE_URL } from "../../../config";

export async function fetchAdminTransactionDesk({
  page = 1,
  limit = 25,
  status = "all",
  desk = "all",
  currency = "all",
  search = "",
  refresh = false,
} = {}) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (status && status !== "all") params.set("status", status);
  if (desk && desk !== "all") params.set("desk", desk);
  if (currency && currency !== "all") params.set("currency", currency);
  if (search) params.set("search", search);
  if (refresh) params.set("refresh", "1");

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/transactions?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}

export async function fetchAdminTransactionDetail(transactionId, { refresh = false } = {}) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams();
  if (refresh) params.set("refresh", "1");
  const qs = params.toString();

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/admin/transactions/${transactionId}${qs ? `?${qs}` : ""}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
